<template>
  <lw-overlay :size="'panel'">
    <div class="grid_sm grid-columns-3_md grid-gap-2 pb-margin">
      <div class="grid-column-span-3_sm grid-column-span-2_md mt3">
        <h1 class="">{{ title }}</h1>
        <div class="measure"><slot name="intro"/></div>
      </div>

      <div class="my3 grid-column-span-3_sm grid-column-span-1_md align-right_md">
        <div
          v-if="primaryNumber"
          class="mb2">
          <h2
            v-if="primaryNumberTitle"
            class="mb0">{{ primaryNumberTitle }}</h2>
          <p class="font-size-1 mb1"><span class="font-size-10 price extra-condensed book mb1">{{ primaryNumber | currency }}</span>{{ primaryNumberUnit }}</p>
        </div>
        <div
          v-if="secondaryNumber"
          :class="secondaryNumberColour + '-text'"
          class="mb1">
          <p class="font-size-3 measure--none mb0">{{ secondaryNumberTitle }}</p>
          <p class="font-size-4 measure--none mb0"><span class="book font-size-7 price extra-condensed">{{ secondaryNumber | currency }}</span></p>
        </div>
        <div
          v-if="tertiaryNumber"
          :class="tertiaryNumberColour + '-text'"
          class="">
          <p class="font-size-3 measure--none mb0">{{ tertiaryNumberTitle }}</p>
          <p class="font-size-4 measure--none mb0"><span class="book font-size-7 price extra-condensed">{{ tertiaryNumber | currency }}</span></p>
        </div>
      </div>

      <div class="grid-column-span-3_sm mb1">
        <h3>Formula</h3>
        <p class="mono medium font-size-2 mb1"><slot name="formula"/></p>

        <h3 class="dark-red-300-text">Break-even formula</h3>
        <p class="mono medium font-size-2 dark-red-300-text"><slot name="break-even-formula"/></p>
      </div>
      <div
        v-if="goodFor || notGoodFor"
        class=" mb3 grid-column-span-3_sm grid p0 grid-columns-2_sm">
        <div v-if="goodFor">
          <h3>Good for:</h3>
          <ul class="inside measure pr2">
            <li
              v-for="item in goodFor"
              :key="item.id">{{ item }}</li>
          </ul>
        </div>

        <div v-if="notGoodFor">
          <h3>Not so good for:</h3>
          <ul class="inside measure pr2">
            <li
              v-for="item in notGoodFor"
              :key="item.id">{{ item }}</li>
          </ul>
        </div>
      </div>

      <slot name="charts"/>
    </div>
  </lw-overlay>
</template>

<script>
import Overlay from '../../livewires/Overlay.vue'

export default {
  components: {
    lwOverlay: Overlay
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    goodFor: {
      type: Array,
      default: null
    },
    notGoodFor: {
      type: Array,
      default: null
    },
    primaryNumber: {
      type: Number,
      default: 0
    },
    primaryNumberUnit: {
      type: String,
      default: ''
    },
    primaryNumberTitle: {
      type: String,
      default: ''
    },
    secondaryNumber: {
      type: Number,
      default: 0
    },
    secondaryNumberTitle: {
      type: String,
      default: 'Estimated break even'
    },
    secondaryNumberColour: {
      type: String,
      default: 'dark-red-300'
    },
    tertiaryNumber: {
      type: Number,
      default: 0
    },
    tertiaryNumberTitle: {
      type: String,
      default: ''
    },
    tertiaryNumberColour: {
      type: String,
      default: 'dark-red-300'
    }
  }
}
</script>

<style>
.panel {
  margin-top: calc(var(--line) * 2.5);
  width: 100%;
  padding-bottom: calc(var(--line) * 6);
}
.legend div {
  font-size: var(--font-size-2);
  margin-bottom: calc(var(--line) * 0.5);
}
.legend div:before {
  content: '';
  display:block;
  width: 0.4em;
  height: 3.2em;
  margin-right: 0.5em;
  vertical-align: baseline;
  border-radius: var(--tight-radius);
  float: left;
}
.legend .salaries:before {
  background-color: var(--light-red);
}
.legend .expenses:before {
  background-color: var(--dark-red);
}
.legend .taxes:before {
  background-color: var(--light-blue);
}
.legend .profit:before {
  background-color: var(--green);
}
.legend .defecit:before {
  background-color: var(--grey-850);
}
@media screen and (min-width: 48em) {
  .panel {
    height: calc(100% - (var(--line) * 3.16));
    margin-top: calc(var(--line) * 3.16);
    width: calc(100% - (var(--line)*12));
  }
}
@media screen and (min-width: 64em) {
  .panel {
    width: calc(100% - (var(--line)*15));
  }
}
</style>
